export function setInitial(state, formName, fieldName, value) {
    let newState = { ...state };
    if (!newState.hasOwnProperty(formName)) {
        newState[formName] = {};
        newState[formName][fieldName] = value;
    } else if (!newState[formName].hasOwnProperty(fieldName)) {
        newState[formName] = {
            ...newState[formName],
            [fieldName]: value,
        };
    }
    return newState;
}

export function valueSet(state, formName, fieldName, value) {
    return {
        ...state,
        [formName]: { ...state[formName], [fieldName]: value },
    };
}

export function removeState(state, formName) {
    if (state[formName]) {
        const { [formName]: toBeRemoved, ...rest } = state;
        return { ...rest };
    }
    return { ...state };
}

export function resetState(state, formName, type) {
    if (state[formName]) {
        const newFormState = Object.keys(state[formName]).reduce(
            (newState, key) => {
                let value;

                switch (type) {
                    case 'values':
                        value =
                            typeof state[formName][key] === 'boolean'
                                ? false
                                : typeof state[formName][key] === 'string'
                                ? ''
                                : null;
                        break;

                    case 'errors':
                        value = true;
                        break;

                    case 'touched':
                        value = false;
                        break;
                    default:
                }

                newState[key] = value;
                return newState;
            },
            {}
        );

        return { ...state, [formName]: newFormState };
    }
    return { ...state };
}
